import { render, staticRenderFns } from "./TrainConfig_classify.vue?vue&type=template&id=0b508133&"
import script from "./TrainConfig_classify.vue?vue&type=script&lang=js&"
export * from "./TrainConfig_classify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports